export const formatDateString = (dateStr: string): string => {
  return new Date(dateStr).toLocaleDateString(undefined, { month: "long", day: "2-digit", year: "numeric" });
};
